export const MEMBER = 'MEMBER'
export const MEMBER_STATUS = 'MEMBER_STATUS'
export const SUBMIT_TEAM_MEMBER_STATUS = 'SUBMIT_TEAM_MEMBER_STATUS'
export const SUBMIT_TEAM_MEMBER = 'SUBMIT_TEAM_MEMBER'
